import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import MembershipCustomTextContent from '../../component/MembershipCustomTextContent/MembershipCustomTextContent'
import HomeApproachText from '../../component/HomeApproachText/HomeApproachText'
import ServicesInnerCardsCarousel from '../../component/ServicesInnerCardsCarousel/ServicesInnerCardsCarousel'
import { Helmet } from 'react-helmet'

const cardD = [
  {
    img: false,
    title: "Consultation",
    para:'A clinician reviews your needs and goals to select or design your infusion.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "Preparation",
    para:'Ingredients are compounded onsite under strict medical supervision.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "Infusion",
    para:'Relax in a lounge setting while receiving your personalized IV, usually over 45–60 minutes.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  {
    link:"/orthopaedic-clinic",
        img:"/images/creatives/service-main-10.webp",
    name:"Orthopaedic Clinic ",
    rank:"",
    para:'Advanced diagnosis and treatment for bones, joints and spine.'
  },
  {
    link:"/naturopathic-medicine",
    img:"/images/creatives/service-main-9.webp",
    name:"Naturopathic Medicine",
    rank:"",
    para:'An integrative approach combining clinical science and natural therapies to optimize health.'
  },
  // {
  //   link:"/mens",
  //       img:"/images/creatives/service-main-11.webp",
  //   name:"Pelvic Floor Therapy – Men",
  //   rank:"",
  //   para:'Targeted treatment for pelvic muscle strength and coordination.'
  // },
]

const listData = [
     {
        img:"/images/creatives/sportsmedicine-text-1.png",
        title:"Why it matters",
        para:"Musculoskeletal health is central to daily function, longevity, and performance—yet often overlooked until injury strikes."
    },
     {
        img:"/images/creatives/sportsmedicine-text-1.png",
        title:"Who it’s for",
        para:"Athletes, high-performers, active adults, or anyone recovering from injury or surgery."
    },
     {
        img:"/images/creatives/sportsmedicine-text-1.png",
        title:"How it works",
        para:"We begin with a biomechanical assessment and clinical history, then match you with the right interventions from our multidisciplinary team."
    },
]

const BoostCardContent = [
    "Accelerate recovery with targeted, medically guided care",
    "Reduce risk of future injuries with functional movement re-training",
    "Improve physical performance through strength and mobility work",
    "Access a multidisciplinary team under one roof",

]

const serviceInnerCardData = [
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Massage Therapy",
    content:"Hands-on treatment to reduce tension, improve circulation, and aid recovery.",
  },
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Podiatry",
    content:"Gait analysis, orthotics, and lower-limb injury prevention.",
  },
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Orthopaedic Surgery Consultation",
    content:"Access to surgical expertise when conservative management isn’t enough.",
  },
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Spinal Decompression & Rehabilitation",
    content:"Non-invasive back pain therapy and postural correction.",
  },
]

function SportsMedicine() {
  return (
     <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Sports Medicine Toronto | Injury Prevention & Rehabilitation
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/sports-medicine"
        />
        <meta
          name="description"
          content="Expert sports medicine in Toronto focused on injury prevention, recovery, and performance optimization. Personalized rehabilitation for athletes and active individuals."
        ></meta>

      </Helmet>
         <Header/>
        <HomeHero
            heading='Sports Medicine'
            // content='Genetic testing that reveals how your DNA influences disease risk, drug metabolism, nutrient processing, and long-term health planning.'
            content='Comprehensive injury prevention, rehabilitation, and performance care for active lives.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/sportsMedhero-image.png"}
            bgImage={"/images/creatives/boost-shoot-bg.png"}
            btnCalnedly={true}
            calendlyType={6}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="A personalized approach"
            para="Our Sports Medicine team provides targeted care for musculoskeletal injuries, movement dysfunctions, and athletic performance challenges. Whether you’re recovering from surgery, managing chronic pain, or seeking to prevent injury, we offer a coordinated, expert-driven plan tailored to your goals."
           bgImg="/images/creatives/service-main-1.webp"
          />

          <MembershipCustomTextContent
            listData={listData}
            shiftRow={true}
            nonSwitchingImg={true}
          />
        </div>

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={BoostCardContent}
        />


      <ServicesInnerCardsCarousel
        heading='Integrated Modalities'
        para="We combine multiple treatment approaches to ensure every patient gets the most effective plan:"
        cardContent={serviceInnerCardData}
      />
        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph="Pair your rehabilitation with services that support performance, recovery, and long-term health."
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
        </div>
    </div>
  )
}

export default SportsMedicine